// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 746 ? "pages-" : chunkId) + "." + {"462":"12a4aa0b","534":"0217c4ec","746":"5271c370"}[chunkId] + ".chunk.js";
};